const BipoTab = () => {
  return <div>BIPO</div>;
};

export default BipoTab;
